import type { IBaseRole } from "@/entities/auth/types.ts"
import type { IQuarterNumber } from "@/shared/types/interfaces"

type IBaseRoleType = Record<Uppercase<IBaseRole>, IBaseRole>
type IBaseRoleTypePartial = Partial<IBaseRoleType>

export const COMPANY_BASE_ROLES = Object.freeze<IBaseRoleTypePartial>({
  ENTERPRISE_ADMIN: "enterprise_admin",
  CHIEF_ENERGETIC: "chief_energetic",
  ENERGETIC: "energetic"
})

export const AUDITOR_BASE_ROLES = Object.freeze<IBaseRoleTypePartial>({
  AUDIT_ADMIN: "audit_admin",
  AUDITOR: "auditor"
})

export const COMPANY_BASE_ROLES_VALUES = Object.values(COMPANY_BASE_ROLES)
export const AUDITOR_BASE_ROLES_VALUES = Object.values(AUDITOR_BASE_ROLES)

export const BASE_ROLES = Object.freeze<IBaseRoleTypePartial>({
  SUPER_ADMIN: "super_admin",
  INSPECTION_ADMIN: "inspection_admin",
  REPUBLIC_INSPECTOR: "republic_inspector",
  REGIONAL_INSPECTOR: "regional_inspector",
  ...AUDITOR_BASE_ROLES,
  ...COMPANY_BASE_ROLES
})

export const quarterNumbers: IQuarterNumber[] = [1, 2, 3, 4] as const

export const FETCH_NOTIFICATIONS_INTERVAL = 15 * 1000 * 60 // 15 minutes
